import { Context, ReactNode, createContext } from "react";
import { ButtonProps } from "@songtradr-one/components-frontend";

// TEXT

// STYLES

// DATA

// TYPES
export type ModalConfirmConfig = {
  title: string;
  description?: string;
  cancelLabel?: string;
  confirmLabel: string;
  confirmVariant?: ButtonProps["$variant"];
  dismissBehavior?: "confirm" | "cancel";
  preventDismiss?: boolean;
  content?: ReactNode;
  onConfirm?: () => Promise<unknown>;
};

export type ModalConfirmContextValue = {
  confirm: (config: ModalConfirmConfig) => Promise<boolean>;
};

// CONSTANTS
export const ModalConfirmContext: Context<ModalConfirmContextValue> =
  createContext<ModalConfirmContextValue>({
    confirm: () => Promise.resolve(false),
  });

// FUNCTIONS

// ASSETS
